(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCrewBatchers.factory:CrewBatchFactory
     *
     * @description
     *
     */
    angular
        .module('configDistribution')
        .factory('ConfigDistributionFactory', ConfigDistributionFactory);

    function ConfigDistributionFactory() {

    	var self = this;
    	var crewTypes = [];
    	var statusList = [];

    	function CrewTypeDTO(){
			this.crewTypeCode = null;
			this.crewTypeDescription = null;
		}

    	function ConfigDTO(){
    		  this.distributionLimitId = null;
    		  this.distributionIdentifier = null;
    		  this.duration = null;
    		  this.maxAllowed = null;
    		  this.status = null;
    		  this.crewTypeCode = null;
    		  this.version = -1;
    	}

    	function GridSearchRequest(){
    		this.distributionIdentifier = null;
    		this.crewType = null;
    		this.duration = null;
    		this.maximumAllowed = null;
    		this.status = null;
    		this.pageSize = null;
    		this.startPosition = null;
    	}


    	function ConfigDeleteRequest(){
    		this.distributionLimitId = null;
    		this.version = null;
    	}


    	function FormatCrewTypeResponse(crewTypes){
      	   var formattedList = [];
  	       angular.forEach(crewTypes, function (crewType) {
  		        var crewTypeDTO = new CrewTypeDTO();

  		       	crewTypeDTO.crewTypeCode = crewType.crewTypeCode;
  		       	crewTypeDTO.crewTypeDescription = crewType.crewTypeDescription;

  		       	formattedList.push(crewTypeDTO);
  	       });

  	       return formattedList;
         }

    	 function FormatGridDataSearchResponse(configs){
    		 var formattedList = [];
    	     angular.forEach(configs, function (config) {
    		      var configDTO = new ConfigDTO();
    		      configDTO.distributionLimitId = config.distributionLimitId;
    		      configDTO.distributionIdentifier = config.distributionIdentifier;
    		      configDTO.duration = config.duration;
             configDTO.minAllowed= config.minAllowed;
    		      configDTO.maxAllowed = config.maxAllowed;
    		      configDTO.status = searchStatus(config.status);
    	    	  configDTO.crewTypeCode = searchCrewTypeName(config.crewTypeCode);
    	    	  configDTO.version = config.version;
    		      formattedList.push(configDTO);
    	      });
    	      return formattedList;
    	 }

    	 function PopulateGridDataSearchRequest(searchCriteria){
    		 var request = new GridSearchRequest();
    		 request.crewType = searchCriteria.crewType != null ? searchCriteria.crewType.crewTypeCode : null;
    		 request.duration = searchCriteria.duration != null ? searchCriteria.duration : null;
    		 request.maximumAllowed = searchCriteria.maximumAllowed != null ? searchCriteria.maximumAllowed : null;
    		 request.status = searchCriteria.status != null ? searchCriteria.status.value : null;
    		 request.distributionIdentifier = searchCriteria.distributionIdentifier != null ? searchCriteria.distributionIdentifier : null;
    		 request.pageSize = searchCriteria.pageSize;
    		 request.startPosition = searchCriteria.startPosition;
    		 return request;
    	 }

    	 function SetCrewTypes(crewTypeList){
    		 crewTypes = crewTypeList;
    	 }

    	 function SetStatus(status){
    		 statusList = status;
    	 }

    	 function searchCrewTypeName(crewTypeCode){
	    	  var selectedCrewType = null;

	    	  angular.forEach(crewTypes, function (crewType) {
	   		      if(crewType.crewTypeCode == crewTypeCode){
	   		    	selectedCrewType = crewType;
	   		      }
	   	      });

	   	      return selectedCrewType;
    	 }

    	 function searchStatus(statusCode){
    		 var selectedStatus = null;

	    	  angular.forEach(statusList, function (status) {
	   		      if(status.value == statusCode){
	   		    	selectedStatus = status;
	   		      }
	   	      });

	   	      return selectedStatus;
    	 }

    	 function GetNewConfig(){
    		 var config =  new ConfigDTO();
    		 config.status = false;
    		 return config;
    	 }

    	 function FormatSelectedRowData(rowData){
    		  var configDTO = new ConfigDTO();
		      configDTO.distributionLimitId = rowData.distributionLimitId;
		      configDTO.distributionIdentifier = rowData.distributionIdentifier;
		      configDTO.duration = rowData.duration;
         configDTO.minAllowed = rowData.minAllowed;
		      configDTO.maxAllowed = rowData.maxAllowed;
		      configDTO.status = rowData.status.value == 'ACT' ? false :true;
	    	  configDTO.crewTypeCode = rowData.crewTypeCode;
	    	  configDTO.version = rowData.version;
	    	  return configDTO;
    	 }

    	 function PopulateUpdateConfigRequest(postdataArray){
    		var requests = [];

    		angular.forEach(postdataArray, function (postData) {
    			var newReq = new ConfigDTO();

    	    	newReq.distributionIdentifier = postData.distributionIdentifier;
    	    	newReq.duration = postData.duration;
            newReq.minAllowed = postData.minAllowed == null ? 0 : postData.minAllowed;
    	    	newReq.maxAllowed = postData.maxAllowed;
    	    	newReq.status = postData.status ? "INA" :"ACT";
    	    	newReq.crewTypeCode = postData.crewTypeCode.crewTypeCode;
    	    	newReq.distributionLimitId = postData.distributionLimitId;
    	    	newReq.version = postData.version;

    	     	requests.push(newReq);
	   	    });

	   	    return requests;
    	 }

    	 function PopulateDeleteRequest(postData){
    		 var request = new ConfigDeleteRequest();
    		 request.distributionLimitId = postData.distributionLimitId;
    		 request.version = postData.version;
    		 return request;
    	 }


        return {
        	formatCrewTypeResponse : FormatCrewTypeResponse,
        	formatGridDataSearchResponse : FormatGridDataSearchResponse,
        	populateGridDataSearchRequest : PopulateGridDataSearchRequest,
        	setCrewTypes : SetCrewTypes,
        	setStatus : SetStatus,
        	getNewConfig : GetNewConfig,
        	formatSelectedRowData : FormatSelectedRowData,
        	populateUpdateConfigRequest : PopulateUpdateConfigRequest,
        	populateDeleteRequest : PopulateDeleteRequest
        }
    }
})();
